var crosspointCustomerFormId = '#RegisterForm'; //会員登録・更新用

$(function(){

    //@汎用処理
    //input要素フォーカス外れたら禁止文字削除
    $(":input").blur(function() {
        var value = $(this).val();
        if(value && $.type(value) == "string"){
            var replacedValue =  value.replace(/｡|ﾟ|№|℡|\\|Ⅰ|Ⅱ|Ⅲ|Ⅳ|Ⅴ|Ⅵ|Ⅶ|Ⅷ|Ⅸ|Ⅹ|ⅰ|ⅱ|ⅲ|ⅳ|ⅴ|ⅵ|ⅶ|ⅷ|ⅸ|ⅹ|∑|√|∟|∠|∥|∩|∪|∫|∮|∵|≒|≡|⊥|⊿|①|②|③|④|⑤|⑥|⑦|⑧|⑨|⑩|⑪|⑫|⑬|⑭|⑮|⑯|⑰|⑱|⑲|⑳|〝|〟|㈱|㈲|㈹|㊤|㊥|㊦|㊧|㊨|㌃|㌍|㌔|㌘|㌢|㌣|㌦|㌧|㌫|㌶|㌻|㍉|㍊|㍍|㍑|㍗|㍻|㍼|㍽|㍾|㎎|㎏|㎜|㎝|㎞|㎡|㏄|㏍|丨|¬|纊|褜|鍈|銈|蓜|俉|炻|昱|棈|鋹|曻|彅|仡|仼|伀|伃|伹|佖|侒|侊|侚|侔|俍|偀|倢|俿|倞|偆|偰|偂|傔|僴|僘|兊|兤|冝|冾|凬|刕|劜|劦|勀|勛|匀|匇|匤|卲|厓|厲|叝|﨎|咜|咊|咩|哿|喆|坙|坥|垬|埈|埇|﨏|塚|增|墲|夋|奓|奛|奝|奣|妤|妺|孖|寀|甯|寘|寬|尞|岦|岺|峵|崧|嵓|﨑|嵂|嵭|嶸|嶹|巐|弡|弴|彧|德|忞|恝|悅|悊|惞|惕|愠|惲|愑|愷|愰|憘|戓|抦|揵|摠|撝|擎|敎|昀|昕|昻|昉|昮|昞|昤|晥|晗|晙|晴|晳|暙|暠|暲|暿|曺|朎|朗|杦|枻|桒|柀|栁|桄|棏|﨓|楨|﨔|榘|槢|樰|橫|橆|橳|橾|櫢|櫤|毖|氿|汜|沆|汯|泚|洄|涇|浯|涖|涬|淏|淸|淲|淼|渹|湜|渧|渼|溿|澈|澵|濵|瀅|瀇|瀨|炅|炫|焏|焄|煜|煆|煇|凞|燁|燾|犱|犾|猤|猪|獷|玽|珉|珖|珣|珒|琇|珵|琦|琪|琩|琮|瑢|璉|璟|甁|畯|皂|皜|皞|皛|皦|益|睆|劯|砡|硎|硤|硺|礰|礼|神|祥|禔|福|禛|竑|竧|靖|竫|箞|精|絈|絜|綷|綠|緖|繒|罇|羡|羽|茁|荢|荿|菇|菶|葈|蒴|蕓|蕙|蕫|﨟|薰|蘒|﨡|蠇|裵|訒|訷|詹|誧|誾|諟|諸|諶|譓|譿|賰|賴|贒|赶|﨣|軏|﨤|逸|遧|郞|都|鄕|鄧|釚|釗|釞|釭|釮|釤|釥|鈆|鈐|鈊|鈺|鉀|鈼|鉎|鉙|鉑|鈹|鉧|銧|鉷|鉸|鋧|鋗|鋙|鋐|﨧|鋕|鋠|鋓|錥|錡|鋻|﨨|錞|鋿|錝|錂|鍰|鍗|鎤|鏆|鏞|鏸|鐱|鑅|鑈|閒|隆|﨩|隝|隯|霳|霻|靃|靍|靏|靑|靕|顗|顥|飯|飼|餧|館|馞|驎|髙|髜|魵|魲|鮏|鮱|鮻|鰀|鵰|鵫|鶴|鸙|黑|ｱ|ｲ|ｳ|ｴ|ｵ|ｶ|ｷ|ｸ|ｹ|ｺ|ｻ|ｼ|ｽ|ｾ|ｿ|ﾀ|ﾁ|ﾂ|ﾃ|ﾄ|ﾅ|ﾆ|ﾇ|ﾈ|ﾉﾊ|ﾋ|ﾌ|ﾍ|ﾎ|ﾏ|ﾐ|ﾑ|ﾒ|ﾓ|ﾔ|ﾕ|ﾖ|ﾗ|ﾘ|ﾙ|ﾚ|ﾛ|ﾜ|ｦ|ﾝｧ|ｨ|ｩ|ｪ|ｫ|ｬ|ｭ|ｮ|ｯ/g,"");
            replacedValue =  replacedValue.replace(/−/g,"-").replace(/―/g,"-");
            $(this).val(replacedValue);
        }
    });

    //@ログイン画面
    if(location.pathname.match(/\/account\/login/)){
        //ログイン同期
        $('#customer_login').submit(function(){
            var syncEmail = $('#CustomerEmail').val();
            syncResult = sysncCustomer(syncEmail);
            return true;//常にtrue
        })

        //パスワードリセット予約
         $('#RecoverEmail').parent().parent().parent().find('form').submit(function(){
            var recoverEmail = $('#RecoverEmail').val();
            reserveResult = reservePwReset(recoverEmail);
            return true;//常にtrue
        })
    }

    //@パスワードリセット画面
    if(location.pathname.match(/\/account\/reset\//) ){
            //パスワードリセット実行
            $('form').submit(function(){
                if(this.action.indexOf('reset')>0){//リセットフォームのsubmit
                    if($('#password').val() == $('#password_confirmation').val()){//同値
                        if($('#password').val().length >= 5 ){
                            excuteResult = excutePwReset(this)
//                            console.log(excuteResult)
                        }else{
                          alert('5文字以上で入力してください');
                          return false;
                        }
                    }else{
                      alert('入力と確認が一致しません');
                      return false;
                    }
                }
                return excuteResult;
            })
    }

      //@パスワードリセット画面
    if(location.pathname.match(/\/account\/activate\//) ){
            //パスワードリセット実行
            $('form').submit(function(){
                if(this.action.indexOf('activate')>0){//リセットフォームのsubmit
                    if($('#password').val() == $('#password_confirmation').val()){//同値
                        if($('#password').val().length >= 5 ){
                            excuteResult = excutePwReset(this)
//                            console.log(excuteResult)
                        }else{
                          alert('5文字以上で入力してください');
                          return false;
                        }
                    }else{
                      alert('入力と確認が一致しません');
                      return false;
                    }
                }
                return excuteResult;
            })
    }

    //@カート画面
    if(location.pathname.match(/\/cart/) ){
        //ポイント利用
        $("#cart").submit(function(){
          var memberId = $('#customerId').val();
          if(!memberId){//会員IDが取得できない場合
            return true
          }
            //クーポン取得
            var cpMessage = getDisacountByCp()
            if (cpMessage){
                return true;
            }
            else{
                return false;
            }
        })
    }

    //@会員登録・会員更新画面
    if(location.pathname.match(/\/account\/register/) ){

    
    var cardNo = getParam('MEMBER_ID');
    var pinCd = getParam('PIN_CD');
    if(cardNo && pinCd){
      $("#RegisterForm-cardNo").val(cardNo);
      $("#RegisterForm-pinCd").val(pinCd);
    }
        //性別 更新時初期値セット
        var sexValue = $(`${crosspointCustomerFormId}-sex-update`).val();
        if (sexValue){
            $('#RegisterForm-sex-3').prop('checked', false);
            $(`#RegisterForm-sex-${sexValue}`).prop('checked', true);
        }
        //都道府県 更新時初期値セット
        var prefnameValue = $(`${crosspointCustomerFormId}-prefname-update`).val();
        if (prefnameValue != null){
            $(`${crosspointCustomerFormId}-prefname-list`).val(prefnameValue);
        }
        //電話番号 更新時初期値セット
        var phoneValue = $(`${crosspointCustomerFormId}-phone-update`).val();
        if (phoneValue != null){
            replacedPhone = phoneValue.replace('+81', '0')
            $(`${crosspointCustomerFormId}-phone`).val(replacedPhone);
        }
        //郵送DM可否 更新時初期値セット
        var postcard_dm_unnecessary_flgValue = $(`${crosspointCustomerFormId}-postcard_dm_unnecessary_flg-update`).val();
        if (postcard_dm_unnecessary_flgValue == "1"){
            $('input:checkbox[name="customer[postcard_dm_unnecessary_flg]"]').prop('checked',false);
        }
        //メルマガ可否 更新時初期値セット
        var accepts_marketingValue = $(`${crosspointCustomerFormId}-accepts_marketing-update`).val();
        if (accepts_marketingValue == "false"){
            $('input:checkbox[name="customer[accepts_marketing]"]').prop('checked',false);
        }
        //カスタム属性 更新時初期値セット
        for (var n = 1; n <= 100; n++) {
            var updateCustomAttribute = $(`${crosspointCustomerFormId}-customattribute${n}-update`); //CPの値取得
            //CPの値が存在するときのみ処理実行
            if (updateCustomAttribute.length){
                var dataType = updateCustomAttribute.data("type");
                var updateValue = updateCustomAttribute.val();
                //selectの場合
                if(dataType == "select"){
                    $(`${crosspointCustomerFormId}-customattribute${n}`).val(updateValue);
                }
                //radioの場合
                else if(dataType == "radio"){
                    var attributes = $(`${crosspointCustomerFormId}-customattribute${n}-wrap`).find("input[type=radio]"); //対象チェック要素
                    attributes.each(function() {
                        if ($(this).val() == updateValue){
                            $(this).prop("checked",true);
                        }
                    });
                }
                //checkboxの場合
                else if(dataType == "checkbox"){
                    var attributes = $(`${crosspointCustomerFormId}-customattribute${n}-wrap`).find("input[type=checkbox]"); //対象チェック要素
                    attributes.each(function() {
                        var inputElement = $(this);
                        if (updateValue.indexOf(",") !== -1){ //複数チェックの場合
                            var updateArray = updateValue.split(",");
                            for (var element of updateArray) {
                                if (inputElement.val() == element){
                                    inputElement.prop("checked",true);
                                }
                            }
                        }else{ //単一チェックの場合
                            if (inputElement.val() == updateValue){
                                inputElement.prop("checked",true);
                            }
                        }
                    });
                }
            }
        }
        //生年月日セット
        var time = new Date();
        var year = time.getFullYear();
        var month = time.getMonth() + 1;
        var date = time.getDate();
        var selectedYear = document.getElementById("year").value;
        var selectedMonth = document.getElementById("month").value;
        for (var i = year; i >= 1900 ; i--) {
            $('#year').append('<option value="' + i + '">' + i + '</option>');
        }
        for (var j = 1; j <= 12; j++) {
            $('#month').append('<option value="' + j + '">' + j + '</option>');
        }
        for (var k = 1; k <= 31; k++) {
            $('#date').append('<option value="' + k + '">' + k + '</option>');
        }
        $('#year').change(function() {
            selectedYear = $('#year').val();
            var last_month = 12;
            if (selectedYear == year) {
                last_month = month;
            }
            $('#month').children('option').remove();
            $('#month').append('<option value="' + 0 + '"> </option>');
            for (var n = 1; n <= last_month; n++) {
                var nStr = n.toString();
                $('#month').append('<option value="' + nStr + '">' + nStr + '</option>');
            }
        });
        $('#year,#month').change(function() {
            selectedYear = $('#year').val();
            selectedMonth = $('#month').val();
            if (selectedYear == year && selectedMonth == month ) {
                var lastDate = date;
            }else{
                //2月は28日まで（閏年は29日）
                if (selectedMonth == 2) {
                    if((Math.floor(selectedYear%4 == 0)) && (Math.floor(selectedYear%100 != 0)) || (Math.floor(selectedYear%400 == 0))){
                        lastDate = 29;
                    }else{
                        lastDate = 28;
                    }
                //4・6・9・11月は30日まで
                }else if(selectedMonth == 4 || selectedMonth == 6 || selectedMonth == 9 || selectedMonth == 11 ){
                    lastDate = 30;
                }else{
                    lastDate = 31;
                }
            }
            $('#date').children('option').remove();
            $('#date').append('<option value="' + 0 + '"> </option>');
            for (var m = 1; m <= lastDate; m++) {
                var mStr = m.toString();
                $('#date').append('<option value="' + mStr + '">' + mStr + '</option>');
            }
        });

        //プレースホルダ挿入
		$("input").focus(function(){
    		var placeholder = $(this).parent().find('.field-placeholder');
          	if(placeholder.length){
              placeholder.removeClass("hide");
          	}
  		}).blur(function(){
    		var placeholder = $(this).parent().find('.field-placeholder');
          	if(placeholder.length){
              placeholder.addClass("hide");
          	}
  		});

        //カスタム属性チェックボックス制御
        $("input[type=checkbox]").click(function(){

            //最大・最小チェック数制御
            var dataLimit = $(this).data("limit");
            var attributeName = $(this).attr('name');
            var checked = $(`input[name='${attributeName}']:checked`);
            if(dataLimit != null){
                var notChecked = $(`input[name='${attributeName}']`).not(':checked')
                if(checked.length >= parseInt(dataLimit,10)) {
                    notChecked.attr("disabled",true);
                }else{
                    notChecked.attr("disabled",false);
                }
            }
            //カンマ区切りで再セット（郵送DM可否とメルマガ可否は除く）
            if(attributeName != "customer[postcard_dm_unnecessary_flg]"){
                if(attributeName != "customer[accepts_marketing]"){
                    var checkedItems = [];
                    var attributeData;
                    var hiddenName = attributeName.replace("[]","");
                    checked.each(function() {
                        checkedItems.push( $(this).val() );
                        attributeData = checkedItems.join(',');
                    });
                    document.getElementById(`${hiddenName}-hidden`).value = attributeData;
                }
            }
        });

        //会員登録/更新フォーム実行
        $("#RegisterForm-submit").click(function submitExcute(){
            //エラー解除
            $(".input-error-message").each(function() {
                $(this).addClass("hide");
            });
            $(".input--error").each(function() {
                $(this).removeClass("input--error");
            });
            $('#ajax-error-message').addClass("hide");

            //エラー判定
            var error = false;

            //パスワード桁数バリデーション
            var passwordMinLength = 5; //桁数
            var passwordValue = $(`${crosspointCustomerFormId}-password`).val();
            if(passwordValue && passwordValue.length < passwordMinLength){
                $(`${crosspointCustomerFormId}-password`).addClass("input--error");
                $(`${crosspointCustomerFormId}-password-error`).removeClass("hide");
                $(`${crosspointCustomerFormId}-password-error-message`).html(`${String(passwordMinLength)}桁以上で入力してください`);
                error = true;
            }
            //カスタム属性必須チェック
            $(".require").each(function() {
                var value = $(this).val();
                var targetId = $(this).attr('id');
                var errorMessageBlock = `#${targetId}-error`;
                var errorMessage = `#${targetId}-error-message`;
                var dataType = $(this).data("type");
                //チェックボックス&ラジオボタン
                if (dataType == "checkbox" || dataType == "radio"){
                    var attributeNameList = targetId.split("-");
                    var checkboxId = `${crosspointCustomerFormId}-${attributeNameList[1]}`;
                    var attributeName = $(this).attr('name');
                    var checkboxErrorMessageLabel = `${checkboxId}-wrap`;
                    var checkboxErrorMessageBlock = `${checkboxId}-error`;
                    var checkboxErrorMessage = `${checkboxId}-error-message`;
                    var checkedItems;
                    var dataMinimum = $(this).data("minimum");
                    $(this).each(function () {
                        checkedItems = $(`input[name='${attributeName}']:checked`).length;
                    });
                    $(checkboxErrorMessageLabel).removeClass("label--error");
                    $(checkboxErrorMessageBlock).addClass("hide");
                    if (dataMinimum != null){
                        if (checkedItems < parseInt(dataMinimum,10)){
                            $(checkboxErrorMessageLabel).addClass("label--error");
                            $(checkboxErrorMessageBlock).removeClass("hide");
                            $(checkboxErrorMessage).html(dataMinimum + "つ以上選択してください");
                            error = true;
                        }
                    }else if (checkedItems === 0){
                        $(checkboxErrorMessageLabel).addClass("label--error");
                        $(checkboxErrorMessageBlock).removeClass("hide");
                        $(checkboxErrorMessage).html("1つ以上選択してください");
                        error = true;
                    }
                //セレクトボックス
                }else if (dataType == "select"){
                    $(this).removeClass("input--error");
                    $(errorMessageBlock).addClass("hide");
                    if (value == "" || value == "選択してください") {
                        $(this).addClass("input--error");
                        $(errorMessageBlock).removeClass("hide");
                        $(errorMessage).html("必須項目です");
                        error = true;
                    }
                }else {
                    $(this).removeClass("input--error");
                    $(errorMessageBlock).addClass("hide");
                    if (value == "" || !value.match(/[^\s\t]/)) {
                        $(this).addClass("input--error");
                        $(errorMessageBlock).removeClass("hide");
                        $(errorMessage).html("必須項目です");
                        error = true;
                    }
                }
            });
            //カスタム属性日付形式チェック
            $(".date-attribute").each(function() {
                var value = $(this).val();
                var targetId = $(this).attr('id');
                var errorMessageBlock = `#${targetId}-error`;
                var errorMessage = `#${targetId}-error-message`;
                var dataform = $(this).data("form");
                if (value != "" || value.match(/[^\s\t]/)) {
                    $(this).removeClass("input--error");
                    $(errorMessageBlock).addClass("hide");
                    if (dataform == "day"){
                        if (!checkDate(value)) {
                            $(this).addClass("input--error");
                            $(errorMessageBlock).removeClass("hide");
                            $(errorMessage).html("正しい年月日形式（例：2021/01/01）で入力してください");
                            error = true;
                        }
                    }else if (dataform == "month"){
                        if (!checkMonth(value)) {
                            $(this).addClass("input--error");
                            $(errorMessageBlock).removeClass("hide");
                            $(errorMessage).html("正しい年月形式（例：2021/01）で入力してください");
                            error = true;
                        }
                    }
                }
            });
            //エラーの場合終了
            if(error){
                $('#ajax-error-message').removeClass("hide");
                $('#ajax-error-message').html("申し訳ございませんが、ご入力いただいた内容に不備がございます。");
                return false;
            }

            //実行ボタン非活性（連続実行禁止）
            $(this).addClass("btn-disable");
            $(".loader").removeClass("hide");

            //ajax実行
            crosspointCheckCustomerApp();
            return true;
        });
    }

    //@住所編集画面
    if(location.pathname.match(/\/account\/addresses/) ){

       //プレースホルダ挿入
      	$("input").focus(function(){
    		var placeholder = $(this).parent().find('.field-placeholder');
          	if(placeholder.length){
              placeholder.removeClass("hide");
          	}
  		}).blur(function(){
    		var placeholder = $(this).parent().find('.field-placeholder');
          	if(placeholder.length){
              placeholder.addClass("hide");
          	}
  		});
      
        //住所追加フォーム
        $("#address_form_new-submit").click(function (){
            var ajaxErrorId = "#address_form_new-ajax-error-message";
        
            //エラー解除
            $(".input-error-message").each(function() {
                $(this).addClass("hide");
            });
            $(".input--error").each(function() {
                $(this).removeClass("input--error");
            });
            $(ajaxErrorId).addClass("hide");

            //実行ボタン非活性（連続実行禁止）
            $(this).addClass("btn-disable");

            //ajax実行
            crosspointCheckAddressApp("#address_form_new",ajaxErrorId);
            return true;
        });

        //住所更新フォーム
        $(".address_form_edit-submit").click(function (){
            var form = $(this).data("address");
            var formId = `#${form}`;
            var ajaxErrorId = `${formId}-ajax-error-message`;
        
            //エラー解除
            $(".input-error-message").each(function() {
                $(this).addClass("hide");
            });
            $(".input--error").each(function() {
                $(this).removeClass("input--error");
            });
            $(ajaxErrorId).addClass("hide");

            //実行ボタン非活性（連続実行禁止）
            $(this).addClass("btn-disable");

            //ajax実行
            crosspointCheckAddressApp(formId,ajaxErrorId);
            return true;
        });
    }
});


//Ajax @ログイン同期
function sysncCustomer(syncEmail){
    var syncResult = $.ajax({
        type: "POST",
        async:false,
        url: "/apps/crosspoint/login-sync",
        //url: "http://localhost:3000/crosspoint_dev/login-sync",
        data: {email: syncEmail},
        success : function(data, dataType) {
            return data;
        },
        //処理がエラーであれば
        error : function() {
            return false;  
        }
    }).responseText
}

//Ajax @パスワードリセット予約
function reservePwReset(recoberemail){
    var reserveResult = $.ajax({
        type: "POST",
        async:false,
        url: "/apps/crosspoint/pw-reset-reserve",
        data: {recoberemail: recoberemail},
        success : function(data, dataType) {
            return data;
        },
        //処理がエラーであれば
        error : function() {
            return false;  
        }
    }).responseText
}

//Ajax @パスワードリセット実行
function excutePwReset(form){
    var hostUrl= '/apps/crosspoint/pw-reset-excute'
    $.ajax({
        url: hostUrl,
        type:'POST',
        dataType: 'json',
        async:false,
        data: $(form).serialize(),
        timeout:3000,
        cache: false,      
    }).done(function(data) {
        if(data.result){
            if(data.status == 'success'){
                return true;
            }else{
                return true;
            }
        }
    }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
        return true;
    })
}

//Ajax  @ポイント利用
function getDisacountByCp(){
    var hostUrl= '/apps/crosspoint/get-coupon';
    var cart = getCart();  
    var memberId = $('#customerId').val();
    var shopIncludeTax = $('#shopIncludeTax').val()
    var usePoint = $("#usePoint").val();
    var apiResul= false;
    var ajaxResult = $.ajax({
        url: hostUrl,
        type:'POST',
        dataType: 'json',
        data: {
            cart: cart,
            memberId: memberId,
            shopIncludeTax:shopIncludeTax,
            usePoint:usePoint
        },
        timeout:30000,
        async : false,
      cache: false,
    }).done(function(data) {
        if(data.result){
            if(data.status == 'success'){
              if(data.result.discountCode){
                //$('#quantityDiscount').val(data.result.discountCode)
                setUseCoupon(data.result.discountCode)
              }else{
                 // $('#quantityDiscount').val(data.result)
                setUseCoupon(data.result)
                }
                apiResul = true;
            }else{
                alert(data.result);
                apiResul = false;
            }
        }else if(data.status == 'skip'){
            apiResul = true;
        }    
    }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
        alert("通信エラーが発生しました。時間をあけて再度お試しください");
    })
    return apiResul;
}

//Ajax @会員登録 or 会員更新バリデーション
function crosspointCheckCustomerApp(){
    //生年月日非活性解除
    $('#year').prop("disabled", false);
    $('#month').prop("disabled", false);
    $('#date').prop("disabled", false);
    var postUrl = document.getElementById("crosspoint-post-url").value;
    //実行
  $.ajax({
    url: postUrl,
    type: 'POST',
    dataType: 'json',
    data: $('#RegisterForm').serialize(),
    timeout: 30000,
  })
    .then(
      function (res) {
        if (res.result) {
          if (res.status == 'success') {
            if (res.update) {
              document.getElementById("RegisterForm-cpToken").value = res.result;
                            if(getParam('MEMBER_ID') && getParam('PIN_CD')){
              document.getElementById("RegisterForm-cpToken").value = res.result+'isFromApp';
              }
              crosspointUpdateCutomerApp(); 

            } else {
              if(getParam('MEMBER_ID') && getParam('PIN_CD')){
                document.getElementById("RegisterForm-cpToken").value = res.result+'isFromApp';
              }else{
                document.getElementById("RegisterForm-cpToken").value = res.result;
              }
             
              
              
              $('#RegisterForm').submit(); 

            }
          } else {
            if (res.result == "shopifyApiError") { 

              $('#ajax-error-message').removeClass("hide");
              $('#ajax-error-message').html("通信エラーが発生しました。もう一度お試しください。");
            } else {
              setErrorMsg(res.result, crosspointCustomerFormId); 

              $('#ajax-error-message').removeClass("hide");
              $('#ajax-error-message').html("申し訳ございませんが、ご入力いただいた内容に不備がございます。");
            }
            setErrorMsg(res.result, crosspointCustomerFormId); 

            $('#ajax-error-message').removeClass("hide");
            $('#ajax-error-message').html("申し訳ございませんが、ご入力いただいた内容に不備がございます。");
            enableButton(); 


            if (res.update) {
              disableBirthDay(); 

            }
          }
        }
      },
        function(){
            $('#ajax-error-message').removeClass("hide");
            $('#ajax-error-message').html("サーバーへの接続に失敗しました。時間をあけて再度お試しください。");
            enableButton(); //実行ボタン活性化
            if (postUrl == '/apps/crosspoint/check-update-member'){
                disableBirthDay(); //生年月日非活性
            }
        }
    );
}

//Ajax @会員更新
function crosspointUpdateCutomerApp(){
    $.ajax({
        url: '/apps/crosspoint/update-member',
        type:'POST',
        dataType: 'json',
        data:{
            id: $(`${crosspointCustomerFormId}-customerId`).val(),
            cpToken: $(`${crosspointCustomerFormId}-cpToken`).val()
        },
        timeout:30000,
    })
    .then(
        function(res){
            if(res.status == 'success'){
                window.location.href = '/account'; //処理成功でアカウントTOPへ遷移
            }else{
                $('#ajax-error-message').removeClass("hide");
                $('#ajax-error-message').html("会員情報の更新に失敗いたしました。申し訳ございませんが、時間をあけて再度お試しください。");
                enableButton(); //実行ボタン活性化
                disableBirthDay(); //生年月日非活性
            }
        },
        function(){
            $('#ajax-error-message').removeClass("hide");
            $('#ajax-error-message').html("サーバーへの接続に失敗しました。時間をあけて再度お試しください。");
            enableButton(); //実行ボタン活性化
            disableBirthDay(); //生年月日非活性
        }
    );
}

//Ajax @住所チェック
function crosspointCheckAddressApp(formId, ajaxErrorId){
    //フォーム要素指定
    var addressForm = $(formId);
    if (formId =="#address_form_new"){ //追加時
        var last_name = "#AddressLastNameNew";
        var first_name = "#AddressFirstNameNew";
        var company = "#AddressCompanyNew";
        var zip = "#AddressZipNew";
        var country = "#AddressCountryNew";
        var province = "#AddressProvinceNew";
        var city = "#AddressCityNew";
        var address1 = "#AddressAddress1New";
        var address2 = "#AddressAddress2New";
        var phone = "#AddressPhoneNew";
        var buttonId = "#address_form_new-submit";
    }else{ //追加時
        var inputId = formId.replace("#address_form_","");
        var last_name = `#AddressLastName_${inputId}`;
        var first_name = `#AddressFirstName_${inputId}`;
        var company = `#AddressCompany_${inputId}`;
        var zip = `#AddressZip_${inputId}`;
        var country = `#AddressCountry_${inputId}`;
        var province = `#AddressProvince_${inputId}`;
        var city = `#AddressCity_${inputId}`;
        var address1 = `#AddressAddress1_${inputId}`;
        var address2 = `#AddressAddress2_${inputId}`;
        var phone = `#AddressPhone_${inputId}`;
        var buttonId = `#submit_${inputId}`;
    }
    //country非活性解除
    $(country).prop("disabled", false);
    //実行
    $.ajax({
        url: '/apps/crosspoint/check-update-address',
        type:'POST',
        dataType: 'json',
        data: {
            address:{
                last_name: $(last_name).val(),
                first_name: $(first_name).val(),
                company: $(company).val(),
                zip: $(zip).val(),
                country: $(country).val(),
                province: $(province).val(),
                city: $(city).val(),
                address1: $(address1).val(),
                address2: $(address2).val(),
                phone: $(phone).val()
            }
        },
        timeout:30000,
    })
    .then(
        function(res){
            if(res.status == 'success'){
                addressForm.submit();
            }else{
                setErrorMsg(res.result, formId); //エラーメッセージセット
                $(ajaxErrorId).removeClass("hide");
                $(ajaxErrorId).html("申し訳ございませんが、ご入力いただいた内容に不備がございます。");
                $(buttonId).removeClass("btn-disable"); //実行ボタン活性化
                $(country).prop("disabled", true); //country非活性化
                return false;
            }
        },
        function(){
            $(ajaxErrorId).removeClass("hide");
            $(ajaxErrorId).html("サーバーへの接続に失敗しました。時間をあけて再度お試しください。");
            $(buttonId).removeClass("btn-disable"); //実行ボタン活性化
            $(country).prop("disabled", true); //country非活性化
            return false;
        }
    );
}

//cart情報の取得 @ポイント利用
function getCart(){
    var result = jQuery.ajax({
        url: '/cart.js',
        dataType: 'json',
        async: false
    }).responseText;
    return result;
}

//0以上の整数のみ @ポイント利用
function isNumber(val){
    var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/);
    return regexp.test(val);
}

//エラーメッセージセット @会員登録・会員更新
function setErrorMsg(messages, formId) {
    for(key in messages){
        //会員登録・会員更新
        if(formId == crosspointCustomerFormId){
            var targetId = `${formId}-${key}`;
        //住所登録・更新
        }else if(formId == "#address_form_new"){
            var upperInitialKey = key.charAt(0).toUpperCase() + key.slice(1);
            var targetId = `#Address${upperInitialKey}New`;
        //住所更新
        }else{
            var inputId = formId.replace("#address_form_","");
            var upperInitialKey = key.charAt(0).toUpperCase() + key.slice(1);
            var targetId = `#Address${upperInitialKey}_${inputId}`;
        }
        if(key == "birthday"){ //誕生日の場合はハイライト3箇所
            $("#year").addClass("input--error");
            $("#month").addClass("input--error");
            $("#date").addClass("input--error");
        }else{
            $(targetId).addClass("input--error");
        }
        $(`${formId}-${key}-error`).removeClass("hide");
        $(`${formId}-${key}-error-message`).html(messages[key]);
    }
}

//生年月非日活性化 @会員登録・会員更新
function disableBirthDay(){
    var yearRegisterValue = $(`${crosspointCustomerFormId}-birthday-update`).val();
    if(yearRegisterValue){
        $('#year').prop("disabled", true);
        $('#month').prop("disabled", true);
        $('#date').prop("disabled", true);
    }
}

//ボタン活性化  @会員登録・会員更新
function enableButton(){
    $(`${crosspointCustomerFormId}-submit`).removeClass("btn-disable");
    $(".loader").addClass("hide");
}

//日付チェック  @会員登録・会員更新
function checkDate(value) {
    //0埋めされてなければfalse
    if (!value.match(/^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/)){
        return false;
    }
    //実際に存在する日付か判定
    var dateString = value.match(/^(\d+)\/(\d+)\/(\d+)$/);
    if (dateString) { 
        var year = parseInt(dateString[1]);
        var month = parseInt(dateString[2]) - 1;
        var day = parseInt(dateString[3]);
        var collectDate = new Date(year, month, day);
        return (year == collectDate.getFullYear() && month == collectDate.getMonth() && day == collectDate.getDate());
    }
    return false;
}

//月チェック  @会員登録・会員更新
function checkMonth(value) {
    //0埋めされてなければfalse
    if (!value.match(/^[0-9]{4}\/(0[1-9]|1[0-2])$/)){
        return false;
    }
    //実際に存在する月か判定
    var dateString = value.match(/^(\d+)\/(\d+)$/);
    if (dateString) { 
        var year = parseInt(dateString[1]);
        var month = parseInt(dateString[2]) - 1;
        var collectDate = new Date(year, month);
        return (year == collectDate.getFullYear() && month == collectDate.getMonth());
    }
    return false;
}

function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function setUseCoupon(code){
  
  var ajaxResult = $.ajax({
        url: '/discount/'+code,
        type:'GET',
        timeout:30000,
        async : false, 
    cache: false,
    }).done(function(data) {
apiResul = false;
    }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
        alert("通信エラーが発生しました。時間をあけて再度お試しください");
    })
    return apiResul;
}